import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { AssetService } from '~/core/services/assets/asset.service';
import { Vehicle } from '~/core/store/trucks/trucks.model.base';
import { CompareService } from '~/modules/admin-shared/services/admin-compare.service';

@Component({
  selector: 'app-compare-banner',
  templateUrl: './compare-banner.component.html',
  styleUrls: ['./compare-banner.component.scss']
})
export class CompareBannerComponent implements OnInit, OnChanges {
  @Input() compareDataId: string[] = [];
  @Input() compareData: Vehicle[] = []; // Ensure this is always initialized

  constructor(
    private translate: TranslateService,
    private compareService: CompareService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private localizeRouterService: LocalizeRouterService,
    private assetService: AssetService
  ) { }

  ngOnInit(): void {
    const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
    this.compareDataId = Array.isArray(sessionTrucks) ? sessionTrucks : [];
    this.fetchCompareData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['compareDataId'] && !changes['compareDataId'].firstChange) {
      this.fetchCompareData();
    }
  }

  private fetchCompareData(): void {
    if (this.compareDataId.length > 0) {
      this.compareService.getCompareData(this.compareDataId).subscribe({
        next: (data: any) => {
          this.compareData = [...(data.items || [])].filter(item => item !== null && item !== undefined);
          this.cdr.detectChanges(); // Manually trigger change detection to ensure UI updates
        },
        error: (error) => {
          console.error('Error fetching compare data:', error);
          this.compareData = [];
        }
      });
    } else {
      this.compareData = [];
      this.cdr.detectChanges(); // Manually trigger change detection
    }
  }

  removeFromComparison(truck: any): void {

    this.compareService.removeFromComparison(truck.truckId);
  }

  clearComparison(): void {
    this.compareService.resetComparison();
  }

  compareTrucks(): void {
    this.router.navigate([this.localizeRouterService.translateRoute("/administration/compare")]);
    // Add navigation or comparison logic here
  }
}

